/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
} from './PersonHandle';

/**
 * 
 * @export
 * @interface SDKEventAuthenticationSucceededV1AllOf
 */
export interface SDKEventAuthenticationSucceededV1AllOf {
    /**
     * Person ID
     * @type {string}
     * @memberof SDKEventAuthenticationSucceededV1AllOf
     */
    person_id: string;
    /**
     * 
     * @type {FactorMethod}
     * @memberof SDKEventAuthenticationSucceededV1AllOf
     */
    success_authn_method: FactorMethod;
    /**
     * 
     * @type {Array<FactorMethod>}
     * @memberof SDKEventAuthenticationSucceededV1AllOf
     */
    authenticated_methods: Array<FactorMethod>;
    /**
     * 
     * @type {PersonHandle}
     * @memberof SDKEventAuthenticationSucceededV1AllOf
     */
    handle?: PersonHandle;
}

/**
 * Check if a given object implements the SDKEventAuthenticationSucceededV1AllOf interface.
 */
export function instanceOfSDKEventAuthenticationSucceededV1AllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "person_id" in value;
    isInstance = isInstance && "success_authn_method" in value;
    isInstance = isInstance && "authenticated_methods" in value;

    return isInstance;
}

export function SDKEventAuthenticationSucceededV1AllOfFromJSON(json: any): SDKEventAuthenticationSucceededV1AllOf {
    return SDKEventAuthenticationSucceededV1AllOfFromJSONTyped(json, false);
}

export function SDKEventAuthenticationSucceededV1AllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventAuthenticationSucceededV1AllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'person_id': json['person_id'],
        'success_authn_method': FactorMethodFromJSON(json['success_authn_method']),
        'authenticated_methods': ((json['authenticated_methods'] as Array<any>).map(FactorMethodFromJSON)),
        'handle': !exists(json, 'handle') ? undefined : PersonHandleFromJSON(json['handle']),
    };
}

export function SDKEventAuthenticationSucceededV1AllOfToJSON(value?: SDKEventAuthenticationSucceededV1AllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'person_id': value.person_id,
        'success_authn_method': FactorMethodToJSON(value.success_authn_method),
        'authenticated_methods': ((value.authenticated_methods as Array<any>).map(FactorMethodToJSON)),
        'handle': PersonHandleToJSON(value.handle),
    };
}

